import { render, staticRenderFns } from "./LmDate.vue?vue&type=template&id=3b2f0527&scoped=true&"
import script from "./LmDate.vue?vue&type=script&lang=js&"
export * from "./LmDate.vue?vue&type=script&lang=js&"
import style0 from "./LmDate.vue?vue&type=style&index=0&id=3b2f0527&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f0527",
  null
  
)

export default component.exports